<div
  class="skymiles-landing-page-menu__sections__section-item"
  id="content_details_body"
>
  <div
    [hidden]="!item.selected"
    class="skymiles-landing-page-menu__sections__section-item__active"
  ></div>
  <a
    (click)="navigateTo($event, item.link)"
    [href]="item.link.url"
    [id]="item.id"
    class="skymiles-landing-page-menu__sections__section-item__label"
  >
    <span class="sr-only">
      {{ indexValue + 1 }}&nbsp;of&nbsp;{{ lengthOfItem }}&nbsp;
    </span>
    {{ item.link.label }}
  </a>
</div>
